/**
 * ApplicationRoutes
 * @description Holds all application routes
 */
export const ApplicationRoutes = {
  // Dashboard
  AdminDashboard: '/user/admin-dashboard',
  // Profile
  UserProfile: '/user/profile',
  EditUserProfile: '/user/edit-profile',
  // Case
  CaseAdd: '/user/case/add',
  CaseView: '/user/case/view',
  CaseEdit: '/user/case/edit',
  CaseCompleted: '/user/case/completed',
  CaseNew: '/user/case/new',
  // Staff User
  InviteUser: '/user/inviteuser',
  UserList: '/user/userslist',
  // Patients
  PatientList: '/user/patientslist',
  AddPatient: '/user/addpatients',
  EditPatient: '/user/editpatients',
  PatientProfile: '/user/patientsprofile',
  PatientSettings: '/user/patient-settings',
  // Radiologist User
  RadiologistInvoiceList: '/user/radiologist-invoice-list',
  RadiologistInvoiceView: '/user/radiologist-invoice/view',
  // Branch
  BranchList: '/user/branchlist',
  SelectBranchLocation: '/select-branch-location',
  // Auth
  Signup: 'signup',
  Login: '/',
};
const UserModules = {
  CASE: 'CASE',
  REPORT: 'REPORT',
  ACCOUNT: 'ACCOUNT',
};
const UserType = {
  USER: 'LOCATION_USER',
  ADMIN: 'LOCATION_ADMIN',
};

/**
 * GeneralUserRoutes
 * @description Holds routes for `USER`
 */
const GeneralUserRoutes = [
  ApplicationRoutes.AdminDashboard,
  // ApplicationRoutes.InviteUser,
  // ApplicationRoutes.UserList,
  // ApplicationRoutes.AddPatient,
  // ApplicationRoutes.EditPatient,
  // ApplicationRoutes.PatientProfile,
  // ApplicationRoutes.PatientSettings,
  // ApplicationRoutes.PatientList,
  ApplicationRoutes.RadiologistInvoiceList,
  ApplicationRoutes.RadiologistInvoiceView,
  ApplicationRoutes.UserProfile,
  ApplicationRoutes.EditUserProfile,
];
/**
 * AdminUserRoutes
 * @description Holds routes for `ADMIN`
 */
const AdminUserRoutes = [
  ...GeneralUserRoutes, 
  // ApplicationRoutes.BranchList
];
/**
 * CaseModuleRoutes
 */
const CaseModuleRoutes = [
  ApplicationRoutes.CaseView,
  ApplicationRoutes.CaseCompleted,
  ApplicationRoutes.CaseNew,
  ApplicationRoutes.CaseEdit,
];
/**
 * ReportModuleRoutes
 */
const ReportModuleRoutes = [];
/**
 * AccountModuleRoutes
 */
const AccountModuleRoutes = [];

/**
 * modulesHierarchy
 */
const ModulesHierarchy = {
  [UserModules.CASE]: CaseModuleRoutes,
  [UserModules.REPORT]: ReportModuleRoutes,
  [UserModules.ACCOUNT]: AccountModuleRoutes,
};

/**
 * UserTypeHierarchy
 */
const UserTypeHierarchy = {
  [UserType.USER]: GeneralUserRoutes,
  [UserType.ADMIN]: AdminUserRoutes,
};

/**
 * userRoutesByActiveModules
 * @param activeModules Active user modules list
 * @returns User's accessible routes for by given active modules
 */
const userRoutesByActiveModules = (activeModules, isSuperAdmin) => {
  if (isSuperAdmin) {
    const allModules = Object.keys(ModulesHierarchy);
    return allModules?.flatMap((item) => ModulesHierarchy[item]) || [];
  }
  return activeModules?.flatMap((item) => ModulesHierarchy[item]) || [];
};

/**
 * userRoutesByUserType
 * @param type User type derived from the `isClinicLocationAdmin` of the selected user location
 * @returns User's accessible routes for given user type
 */
const userRoutesByUserType = (userType, isSuperAdmin) => {
  if (isSuperAdmin) {
    return UserTypeHierarchy[UserType.ADMIN] || [];
  }
  return UserTypeHierarchy[userType || ''] || [];
};

/**
 * getDisabledRoutes
 * @returns List of disabled routes in the application
 */
const getDisabledRoutes = () => {
  // Add any routes to be disabled on live
  return [];
};

/**
 * getUserApplicationRoutes
 * @param selectedLocation User selected branch location, it holds data like `isClinicLocationAdmin` & `modules`
 * @returns Active application routes for the user
 */
export const getUserApplicationRoutes = (selectedLocation, isSuperAdmin=true) => {
  const userRoutesByModules = userRoutesByActiveModules(
    selectedLocation?.modules,
    isSuperAdmin
  );
  const userRoutesByType = userRoutesByUserType(
    selectedLocation?.isClinicLocationAdmin ? UserType.ADMIN : UserType.USER,
    isSuperAdmin
  );

  return (
    userRoutesByType
      // Add user's active module routes
      .concat(userRoutesByModules)
      // Filter disabled application routes
      .filter((route) => !getDisabledRoutes().includes(route))
  );
};
